import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

import DspxModal from '../../../common/DspxModal/DspxModal';

import { texts } from '../../../../constants/texts';

export const ChessChoiceModal = ({
  onCancel,
  onSetManual,
  onSetByFile,
  ...props
}) => {
  return (
    <DspxModal
      title={texts.chooseFlatsGridCreationMethod}
      cancelText={texts.cancel}
      width={651}
      onCancel={onCancel}
      destroyOnClose
      footer={null}
      {...props}
    >
      <Button
        type="primary"
        onClick={onSetByFile}
      >
        Загрузить
      </Button>
      <div>
        Данный способ загрузки происходит с помощью импортирования файла в excel
        формате. Вы сможете сформировать “шахматку” в файле и загрузить файл в
        систему.
      </div>

      <hr />

      <Button
        type="primary"
        onClick={onSetManual}
      >
        Создать
      </Button>
      <div>
        Данный способ загрузки происходит с помощью настройки параметров в
        интерфейсе системы. Вы сможете сформировать “шахматку” путем ввода
        соответствующих данных в систему.
      </div>
    </DspxModal>
  );
};

ChessChoiceModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSetManual: PropTypes.func.isRequired,
  onSetByFile: PropTypes.func.isRequired,
};
